// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { DARKER_SAVANT_GREEN } from './utils/constants.ts'
import { RemoveButtonProps } from './utils/types.ts'

export default function RemoveButton({ x, y, symbol }: RemoveButtonProps) {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <circle
                cx={0}
                cy={0}
                r={6}
                fill={DARKER_SAVANT_GREEN}
                stroke={DARKER_SAVANT_GREEN}
                strokeWidth="2"
            />
            <text
                x={0}
                y={1}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="16"
                fontWeight="bold"
                fill="white"
            >
                {symbol}
            </text>
        </g>
    )
}
